export function openInspectionsMessage(openInspections) {
    return `This application has ${openInspections.length} open inspection(s):\n` +
        openInspections.map(name => `- ${name}`).join('\n') +
        '\n\nAre you sure you want to proceed?';
}
